import React, { useState, useRef } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import DeleteIcon from '@mui/icons-material/Delete'; // Updated to match Material UI
import { sendRequestDocuments } from '../../Helper/adminModuleApi';

const RequestDocumentPopup = ({ isDialogOpen, handleClose, handleRequestNewDocument, onRequestAdded }) => {
    const [documentName, setDocumentName] = useState('');
    const [reason, setReason] = useState('');
    const [files, setFiles] = useState([]);

    const resetFields = () => {
        setDocumentName('');
        setReason('');
        setFiles([]);
    }
    const fileInputRef = useRef(null);  // Step 1: Create a ref for the file input

    const handleSubmit = async () => {
        onRequestAdded({
            documentName: documentName,
            reason: reason,
            status: 'Requested'
        })
        await handleProcess();
        await handleRequestNewDocument(documentName, reason);
        resetFields();
        handleClose();
    };



    const handleDeleteFile = (index) => {
        setFiles(prevFiles => prevFiles.filter((file, i) => i !== index));
        fileInputRef.current.value = '';  // Step 2: Reset the file input value after deleting a file
    };

    const handleProcess = async () => {
        const validFiles = files.filter(file => !file.isOversized);
        const fileSentActivity = validFiles.map(file => ({
            "file_name": file.name,
            "status": "Success",
            "data": file.data,
            "file_type": file.type,
            "company": localStorage.getItem('companyName'),
            "created_date": new Date()
        }));
        const companyUuid = JSON.parse(localStorage.getItem('userDetails')).company_uuid;
        const payload = { "document_name": documentName, "reason": reason, "company_uuid": companyUuid, "user_id": localStorage.getItem('user_id'), files: fileSentActivity };
        await sendRequestDocuments(payload);
    };

    const handleUploadDocuments = (event) => {
        const selectedFiles = event.target.files;
        if (selectedFiles.length > 0) {
            const filesArray = Array.from(selectedFiles);
            Promise.all(filesArray.map(file => readFileAsBase64(file)))
                .then(dataArray => {
                    const updatedFiles = dataArray.map((data, index) => ({
                        name: filesArray[index].name,
                        type: filesArray[index].type,
                        data: data,
                        isOversized: filesArray[index].size > 4 * 1024 * 1024
                    }));

                    setFiles(prevFiles => [...prevFiles, ...updatedFiles]);
                })
                .catch(error => console.error('Error reading files:', error));
        }
    };

    const readFileAsBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result.split(',')[1]);
            reader.onerror = error => reject(error);
            reader.readAsDataURL(file);
        });
    };

    // Validation condition for the Request button
    const isFormValid = documentName && reason && files.length > 0 && files.every(file => !file.isOversized);

    return (
        <Dialog open={isDialogOpen} onClose={handleClose} maxWidth="md" fullWidth>
            <DialogTitle>Request New Document</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Document Name"
                    type="text"
                    fullWidth
                    value={documentName}
                    onChange={(e) => setDocumentName(e.target.value)}
                />
                <TextField
                    margin="dense"
                    label="Reason"
                    type="text"
                    fullWidth
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                />
            </DialogContent>
            <div>
                {files.length > 0 ? (
                    files.map((file, index) => (
                        <div key={index} className="file-item pt-1 mx-5">
                            <span>{index + 1}. {file.name}</span>
                            {file.isOversized && <span className='file-size-warning'> &gt;4MB</span>}
                            <DeleteIcon className='p-0 fl-r' onClick={() => handleDeleteFile(index)} />
                        </div>
                    ))
                ) : (
                    <span className='ml-5'>Please upload at least 1 document to raise request</span>
                )}
            </div>
            <DialogActions style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                    <span style={{ marginBottom: '8px', fontStyle: 'italic', color: '#666' }} className='ml-5'>
                        Please upload sample documents (max: 5)
                    </span>
                    <Button
                        variant="contained"
                        component="label"
                        color="primary"
                        className="theme-bg"
                        size="small"
                        style={{ maxWidth: '150px', padding: '6px 12px', marginLeft: '5%', display: 'flex', alignItems: 'center' }}
                    >
                        <FileUploadIcon style={{ marginRight: '8px' }} ></FileUploadIcon>
                        Upload File
                        <input
                            ref={fileInputRef}  // Step 3: Add the ref to the input element
                            type="file"
                            accept="application/pdf , image/jpeg"
                            hidden
                            multiple
                            onChange={handleUploadDocuments}
                        />
                    </Button>
                </div>
                <div style={{ display: 'flex', gap: '16px' }}>
                    <Button onClick={handleClose} color="primary">Cancel</Button>
                    <Button
                        onClick={handleSubmit}
                        className="theme-bg"
                        color="primary"
                        variant="contained"
                        disabled={!isFormValid} // Disable if form validation fails
                    >
                        Request
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    );
};

export default RequestDocumentPopup;
